/**
 * IANA-таймзона по городу ПВЗ.
 * Время доставки/заказа показываем в поясе магазина, не в поясе браузера.
 */
const CITY_TIMEZONE: Record<string, string> = {
  москва: 'Europe/Moscow',
  'санкт-петербург': 'Europe/Moscow',
  петербург: 'Europe/Moscow',
  спб: 'Europe/Moscow',
  краснодар: 'Europe/Moscow',
  казань: 'Europe/Moscow',
  'нижний новгород': 'Europe/Moscow',
  владимир: 'Europe/Moscow',
  'ростов-на-дону': 'Europe/Moscow',
  таганрог: 'Europe/Moscow',
  шахты: 'Europe/Moscow',
  самара: 'Europe/Samara',
  сызрань: 'Europe/Samara',
  тольятти: 'Europe/Samara',
  ульяновск: 'Europe/Samara',
  уфа: 'Asia/Yekaterinburg',
  пермь: 'Asia/Yekaterinburg',
  екатеринбург: 'Asia/Yekaterinburg',
  'нижний тагил': 'Asia/Yekaterinburg',
  челябинск: 'Asia/Yekaterinburg',
  омск: 'Asia/Omsk',
  новосибирск: 'Asia/Novosibirsk',
  барнаул: 'Asia/Barnaul',
  томск: 'Asia/Tomsk',
  кемерово: 'Asia/Novokuznetsk',
  новокузнецк: 'Asia/Novokuznetsk',
  красноярск: 'Asia/Krasnoyarsk',
  иркутск: 'Asia/Irkutsk',
  хабаровск: 'Asia/Vladivostok',
  калининград: 'Europe/Kaliningrad',
  волгоград: 'Europe/Volgograd',
  саратов: 'Europe/Saratov',
  воронеж: 'Europe/Moscow',
  архангельск: 'Europe/Moscow',
  астрахань: 'Europe/Astrakhan',
  брянск: 'Europe/Moscow',
  иваново: 'Europe/Moscow',
  ижевск: 'Europe/Samara',
  калуга: 'Europe/Moscow',
  киров: 'Europe/Moscow',
  кострома: 'Europe/Moscow',
  курган: 'Asia/Yekaterinburg',
  курск: 'Europe/Moscow',
  липецк: 'Europe/Moscow',
  мурманск: 'Europe/Moscow',
  'набережные челны': 'Europe/Moscow',
  'новый уренгой': 'Asia/Yekaterinburg',
  орел: 'Europe/Moscow',
  орёл: 'Europe/Moscow',
  оренбург: 'Asia/Yekaterinburg',
  пенза: 'Europe/Moscow',
  петрозаводск: 'Europe/Moscow',
  псков: 'Europe/Moscow',
  рязань: 'Europe/Moscow',
  смоленск: 'Europe/Moscow',
  сочи: 'Europe/Moscow',
  ставрополь: 'Europe/Moscow',
  сургут: 'Asia/Yekaterinburg',
  тамбов: 'Europe/Moscow',
  тверь: 'Europe/Moscow',
  тула: 'Europe/Moscow',
  тюмень: 'Asia/Yekaterinburg',
  чебоксары: 'Europe/Moscow',
  ярославль: 'Europe/Moscow',
};

function normalizeCity(city: string): string {
  return city.trim().toLowerCase().replace(/ё/g, 'е');
}

/** Таймзона ПВЗ по городу; по умолчанию Москва. */
export function getTimezoneByCity(city?: string | null): string {
  if (!city) return 'Europe/Moscow';
  return CITY_TIMEZONE[normalizeCity(city)] ?? 'Europe/Moscow';
}
